export interface TeamMember {
  name: string
  role: string
  bio: string
  photoUrl?: string
  linkedinUrl?: string
}

/**
 * About page's "Meet the Team" section (and its Person schema) only render
 * when this has real entries — see AboutPage.tsx. Left empty deliberately:
 * naming real people is one of the strongest E-E-A-T signals a site can
 * carry, but inventing fake names/bios to fill this in would be worse than
 * leaving the gap, both ethically and because a fabricated "team" that
 * turns out not to exist actively destroys trust once discovered.
 *
 * To populate: add real name, role, and a genuine one-sentence bio per
 * person. photoUrl and linkedinUrl are optional but strengthen the signal
 * further (a linked, verifiable identity is more credible than a name
 * alone).
 *
 * Example:
 * export const TEAM_MEMBERS: TeamMember[] = [
 *   {
 *     name: 'Jane Doe',
 *     role: 'Founder & CEO',
 *     bio: 'Spent 6 years running social media for creator agencies before building PlanWise to fix the tooling gap she kept hitting.',
 *     photoUrl: '/team/jane-doe.jpg',
 *     linkedinUrl: 'https://www.linkedin.com/in/janedoe',
 *   },
 * ]
 */
export const TEAM_MEMBERS: TeamMember[] = []
